const AR = {
  // Navbar

  "main-tab": "رئيسية",
  "service-tab": "خدماتنا",
  "join-tab": "انضمام",
  "jobs-tab": "وظائف",
  "visit-tab": "زيارة الموقع",
  "logo-text-1": "خدمات التنظيف",
  "logo-text-2": "السعودية",
  "our-profile-tab": "ملفنا التعريفي",
  "arabic-key": "عر",
  "english-key": "إن",
  "about-us-tab": "من نحن؟",
  "define-system": "تعريف النظام",

  // ==========================================================================================================================================

  // Auto Slider

  // ******  labels
  "first-slider-label": "عنوان أول صورة",
  "second-slider-label": "عنوان ثان صورة",
  "third-slider-label": "عنوان ثالث صورة",

  // ******  Content
  "first-slider-content": "بعض الكلمات المعبرة عن الصورة الأولى",
  "second-slider-content": "بعض الكلمات المعبرة عن الصورة الثانية",
  "third-slider-content": "بعض الكلمات المعبرة عن الصورة الثالثة",

  // ==========================================================================================================================================

  // Services

  // ******  Headers
  "services-header": "خدماتنا و ميزاتنا",
  "first-service-header": "نظام يعمل على جميع المنصات",
  "second-service-header": "نظام واحد متكامل",
  "third-service-header": "الإدارة المالية",
  "fourth-service-header": "يوفر فرص عمل ",

  // ******  Content
  "first-service-content":
    "يتميز النظام بتوفير نسخ منه تعمل على منصات تشغيل مختلفة مثل الويب والديسكتوب والموبايل، مما يعطيه المرونة والسلاسة في الاستخدام وترك حرية الاختيار للمستخدم. استهداف أكبر شريحة ممكنة من المستخدمين.",
  "second-service-content":
    "نظام متكامل موحد لإدارة خدمات التنظيف في جميع أنحاء مملكة السعودية، ولتنظيم العملاء وعمال التوصيل والمغاسل وأتمتة الخدمات بينهم من مكان واحد وبسهولة.",
  "third-service-content":
    "إدارة المدفوعات والمبالغ المستحقة والمطلوبة ،ومتابعة الأمور المالية والاحصاءات بالنسبة لكل من العملاء وعمال التوصيل والمغاسل، وكل ذلك من خلف الشاشة. بالاضافة لإمكانية الدفع وتداول الأموال عن طريق منصات مختلفة.",
  "fourth-service-content":
    "يساعد النظام على توفير فرص عمل بسهولة دون الحاجة لخبرات صعبة أوشهادات من طالب الوظيفة، فمثلا يمكن العمل ضمن النظام كعامل توصيل التي لا تحتاج سوى إلى مركبة للتوصيل لبدء العمل. توفير بيئة عمل مريحة ومرنة تناسب أصحاب الوظائف المتعددة، ولتأمين أكثر من مصدر دخل",

  // ******  Buttons
  "first-service-button": "ادفع فاتورتك",
  "second-service-button": "اشحن رصيدك",

  // ==========================================================================================================================================

  // Contact Us

  // ******  Headers
  "contactUs-header": "تواصل معنا",
  "first-contactUs-header": "معلومات التواصل",
  "second-contactUs-header": "اترك لنا رسالة",

  // ******  Communicate Column
  "location-communicate-label": "العنوان",
  "location-communicate-value": "المملكة العربية السعودية - الدمام",
  "phone-communicate-label": "الهاتف",
  "phone-communicate-value": "55 590 733 0 966+",
  "email-communicate-label": "البريد الالكتروني",
  "email-communicate-value": "mohammad@gmail.com",

  // ******  send message Column
  "name-label": "الاسم",
  "name-placeholder": "اسمك",
  "email-send-message-label": "البريد الالكتروني",
  "email-send-message-placeholder": "example@gmail.com",
  "message-contactUs-label": "الرسالة",
  "message-contactUs-placeholder": "ماذا تريد إخبارنا",
  "button-send-message-contactUs": "إرسال",

  // ==========================================================================================================================================

  // Join Us

  // ******  Headers
  "joinUs-header": "انضم إلينا",

  // ******  Content
  "first-joinUS-content":
    "بإمكانك الانضمام إلينا ، والاستفادة من خدماتنا بسهولة و بتوفير كبير للوقت و الجهد.",

  // ******  Buttons
  "first-joinUs-button": "ابدأ",
  "second-joinUs-button": "جولة تعريفية",

  // ==========================================================================================================================================

  // Footer
  "copy-right": "جميع الحقوق محفوظة لدى خدمات التنظيف السعودية ©",
  "download-desktop": "تحميل تطبيق الويندوز",
  "download-android": "تحميل تطبيق الأندرويد",
  "download-iphone": "تحميل تطبيق الأيفون",
};

export default AR;
